import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/sales-delivery-items`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/sales-delivery-items/${id}?include=`, options)
    .then((response) => {
      let salesdelivery = jsona.deserialize(response.data);
      delete salesdelivery.links;
      return salesdelivery;
    });
}

function add(salesdelivery) {
  const payload = jsona.serialize({
    stuff: salesdelivery,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/sales-delivery-items?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(salesdelivery) {
  const payload = jsona.serialize({
    stuff: salesdelivery,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/sales-delivery-items/${salesdelivery.id}?include=`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/sales-delivery-items/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
